import { EventStatusFromAPI } from "@api/routers/events";
import { getTailwindColorFromEventStatus } from "@utils/getTailwindColorFromEventStatus";

const EventStatusChip = ({ status }: { status: EventStatusFromAPI }) => {
  return (
    <div className={`border border-x-2 ${getTailwindColorFromEventStatus(status).borderColor} px-1.5 flex items-center justify-center rounded-full`}>
      <p className={`${getTailwindColorFromEventStatus(status).textColor} uppercase text-xs font-semibold`}>{status}</p>
    </div>
  );
};

export default EventStatusChip;
